import { render, staticRenderFns } from "./build_Mhh_fc_dashboard.vue?vue&type=template&id=64028827&scoped=true"
import script from "./build_Mhh_fc_dashboard.vue?vue&type=script&lang=js"
export * from "./build_Mhh_fc_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_Mhh_fc_dashboard.vue?vue&type=style&index=0&id=64028827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64028827",
  null
  
)

export default component.exports